(() => {
  const root = document.querySelector('[data-csi-search]');
  if (!root) return;

  const config = window.CSI_SEARCH || {};
  const searchEndpoint = config.searchUrl || '/apps/csi-search/search';
  const shopContext = window.__SHOP_CONTEXT__ || {};
  const isLoggedIn = Boolean(config.isLoggedIn ?? shopContext.isLoggedIn);
  const isCompanyLoggedIn = Boolean(
    config.isCompanyLoggedIn ?? shopContext.isCompanyLoggedIn,
  );
  const loginUrl = config.loginUrl || '/account/login';
  const CARET_SVG =
    '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
  const QUOTE_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/></svg>';
  const CART_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>';
  const CHEVRON_LEFT_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
  const CHEVRON_RIGHT_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';

  const FACET_VISIBLE_COUNT = 8;
  const SKELETON_MIN_MS = 320;
  const SKELETON_STYLE_ID = 'csi-search-skeleton-style';
  const expandedFacets = new Set();
  let skeletonShownAt = 0;
  let loadingGeneration = 0;

  const state = {
    scopeQuery: '',
    refineQuery: '',
    collectionHandle: root.dataset.collectionHandle || '',
    collectionTitle: root.dataset.collectionTitle || '',
    collectionUrl: root.dataset.collectionUrl || window.location.pathname,
    sortId: 'relevance',
    filters: [],
    offset: 0,
    limit: Number(root.dataset.pageSize || 12),
    priceBounds: null,
    abortController: null,
    hasLoadedOnce: false,
    categoryTrail: [],
  };

  const els = {
    form: root.querySelector('[data-csi-search-form]'),
    input: root.querySelector('[data-csi-query-input]'),
    status: root.querySelector('[data-csi-status]'),
    facets: root.querySelector('[data-csi-facets]'),
    activeFilters: root.querySelector('[data-csi-active-filters]'),
    list: root.querySelector('[data-csi-product-list]'),
    empty: root.querySelector('[data-csi-empty]'),
    pagination: root.querySelector('[data-csi-pagination]'),
    sort: root.querySelector('[data-csi-sort]'),
    loading: root.querySelector('[data-csi-loading]'),
    sidebar: root.querySelector('[data-csi-sidebar]'),
    filtersBackdrop: root.querySelector('[data-csi-filters-backdrop]'),
    filtersOpenBtns: root.querySelectorAll('[data-csi-filters-open]'),
    filtersCloseBtns: root.querySelectorAll('[data-csi-filters-close]'),
  };

  const showVendor = root.dataset.showVendor === 'true';

  function setFiltersOpen(open) {
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    root.classList.toggle('is-filters-open', open && isMobile);
    document.body.classList.toggle('csi-filters-open', open && isMobile);
    if (els.filtersBackdrop) {
      els.filtersBackdrop.hidden = !(open && isMobile);
    }
    els.filtersOpenBtns.forEach((btn) => {
      btn.setAttribute('aria-expanded', open && isMobile ? 'true' : 'false');
    });
    if (els.sidebar) {
      if (isMobile) {
        els.sidebar.setAttribute('aria-hidden', open ? 'false' : 'true');
      } else {
        els.sidebar.removeAttribute('aria-hidden');
      }
    }
  }

  function closeFiltersDrawer() {
    setFiltersOpen(false);
  }

  function openFiltersDrawer() {
    setFiltersOpen(true);
  }

  function combineScopeRefine(scope, refine) {
    const a = String(scope || '').trim();
    const b = String(refine || '').trim();
    if (!a) return b;
    if (!b) return a;
    if (a.toLowerCase() === b.toLowerCase()) return a;
    return `${a} ${b}`;
  }

  function effectiveSearchQuery() {
    return combineScopeRefine(state.scopeQuery, state.refineQuery);
  }

  /** Scope from header/global search; in-page input edits refine when scope is set. */
  function usesRefineInput() {
    return Boolean(state.collectionHandle || state.scopeQuery);
  }

  function syncQueryInputFromState() {
    if (!els.input) return;
    els.input.value = usesRefineInput() ? state.refineQuery : effectiveSearchQuery();
    if (state.scopeQuery && usesRefineInput()) {
      els.input.placeholder = `Refine “${state.scopeQuery}”…`;
    }
  }

  function applyInputToState(rawValue) {
    const value = String(rawValue || '').trim();
    if (usesRefineInput()) {
      state.refineQuery = value;
    } else {
      state.scopeQuery = value;
      state.refineQuery = '';
    }
  }

  function readScopeRefineFromParams(params) {
    let scope = params.get('scope')?.trim() || '';
    let refine = params.get('refine')?.trim() || '';
    const legacyQ = params.get('q')?.trim() || '';
    if (!scope && legacyQ) {
      scope = legacyQ;
    }
    if (!scope) {
      scope = root.dataset.initialQuery?.trim() || '';
    }
    return { scope, refine };
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function filterKey(filter) {
    if (filter.productVendor) return `vendor:${filter.productVendor}`;
    if (filter.productType) return `type:${filter.productType}`;
    if (filter.tag) return `tag:${filter.tag}`;
    if (filter.productMetafield) {
      return `mf:${filter.productMetafield.namespace}.${filter.productMetafield.key}:${filter.productMetafield.value}`;
    }
    if (filter.price) {
      return `price:${filter.price.min ?? ''}-${filter.price.max ?? ''}`;
    }
    return JSON.stringify(filter);
  }

  function truncateTitle(title, max = 72) {
    const value = String(title || '');
    if (value.length <= max) return value;
    return `${value.slice(0, max - 3)}...`;
  }

  function displayCollectionTitle(title) {
    const value = String(title || '').trim();
    if (!value) return '';
    const parts = value.split('-');
    if (parts.length > 1 && /^\d+(\.\d+)*$/.test(parts[0].trim())) {
      return parts.slice(1).join('-').trim() || value;
    }
    return value;
  }

  function parseCategoryTrail(raw) {
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .filter((entry) => entry && entry.handle && entry.url)
        .map((entry) => ({
          handle: String(entry.handle),
          title: displayCollectionTitle(entry.title || entry.handle),
          url: String(entry.url),
        }));
    } catch {
      return [];
    }
  }

  function readUrlState() {
    const params = new URLSearchParams(window.location.search);
    const { scope, refine } = readScopeRefineFromParams(params);
    state.scopeQuery = scope;
    state.refineQuery = refine;
    state.sortId = params.get('sortId') || 'relevance';
    state.offset = Math.max(0, Number(params.get('offset') || 0) || 0);
    state.categoryTrail = parseCategoryTrail(params.get('csi_trail'));
    try {
      const filters = params.get('filters');
      state.filters = filters ? JSON.parse(filters) : [];
      if (!Array.isArray(state.filters)) state.filters = [];
    } catch {
      state.filters = [];
    }
    syncQueryInputFromState();
    if (els.sort) els.sort.value = state.sortId;
  }

  function writeUrlState() {
    const params = new URLSearchParams();
    if (state.scopeQuery) params.set('scope', state.scopeQuery);
    if (state.refineQuery) params.set('refine', state.refineQuery);
    if (state.sortId && state.sortId !== 'relevance') params.set('sortId', state.sortId);
    if (state.offset > 0) params.set('offset', String(state.offset));
    if (state.filters.length > 0) params.set('filters', JSON.stringify(state.filters));
    if (state.categoryTrail.length > 0) {
      params.set('csi_trail', JSON.stringify(state.categoryTrail));
    }
    const next = `${window.location.pathname}${params.toString() ? `?${params}` : ''}`;
    window.history.replaceState({}, '', next);
    renderCategoryTree();
  }

  function buildCollectionHref(url, trail) {
    const next = new URL(url, window.location.origin);
    if (state.scopeQuery) next.searchParams.set('scope', state.scopeQuery);
    else next.searchParams.delete('scope');
    if (state.refineQuery) next.searchParams.set('refine', state.refineQuery);
    else next.searchParams.delete('refine');
    next.searchParams.delete('q');
    if (state.sortId && state.sortId !== 'relevance') {
      next.searchParams.set('sortId', state.sortId);
    } else {
      next.searchParams.delete('sortId');
    }
    if (state.filters.length > 0) {
      next.searchParams.set('filters', JSON.stringify(state.filters));
    } else {
      next.searchParams.delete('filters');
    }
    next.searchParams.delete('offset');
    if (trail.length > 0) {
      next.searchParams.set('csi_trail', JSON.stringify(trail));
    } else {
      next.searchParams.delete('csi_trail');
    }
    return `${next.pathname}${next.search}`;
  }

  function currentCollectionCrumb() {
    return {
      handle: state.collectionHandle,
      title: displayCollectionTitle(state.collectionTitle || state.collectionHandle),
      url: state.collectionUrl || window.location.pathname,
    };
  }

  function updateBreadcrumbs() {
    const container = document.querySelector('.breadcrumb-items');
    if (!container || !state.collectionHandle) return;

    const icon = container.querySelector('.home-icon-container');
    const iconHtml = icon ? icon.outerHTML : '';
    const crumbs = [...state.categoryTrail, currentCollectionCrumb()];
    const parts = [`<a href="/" title="Home">Home</a>`];

    crumbs.forEach((crumb, index) => {
      const isLast = index === crumbs.length - 1;
      parts.push(`<span class="breadcrumb-delimeter" aria-hidden="true">></span>`);
      if (isLast) {
        parts.push(
          `<span class="breadcrumb-current" aria-current="page">${escapeHtml(crumb.title)}</span>`,
        );
      } else {
        const href = buildCollectionHref(crumb.url, state.categoryTrail.slice(0, index));
        parts.push(`<a href="${escapeHtml(href)}">${escapeHtml(crumb.title)}</a>`);
      }
    });

    container.innerHTML = `${iconHtml}${parts.join('\n')}`;
  }

  function renderCategoryTree() {
    const categoriesRoot = root.querySelector('[data-csi-categories]');
    if (!categoriesRoot || !state.collectionHandle) return;

    const trailEl = categoriesRoot.querySelector('[data-csi-category-trail]');
    const listEl = categoriesRoot.querySelector('[data-csi-category-list]');
    if (!listEl) return;

    if (trailEl) {
      if (state.categoryTrail.length === 0) {
        trailEl.hidden = true;
        trailEl.innerHTML = '';
      } else {
        trailEl.hidden = false;
        const current = currentCollectionCrumb();
        const items = [...state.categoryTrail, current]
          .map((crumb, index, all) => {
            const isLast = index === all.length - 1;
            if (isLast) {
              return `<span class="csi-search__category-trail-current">${escapeHtml(crumb.title)}</span>`;
            }
            const href = buildCollectionHref(
              crumb.url,
              state.categoryTrail.slice(0, index),
            );
            return `<a href="${escapeHtml(href)}" class="csi-search__category-trail-link">${escapeHtml(crumb.title)}</a>`;
          })
          .join('<span class="csi-search__category-trail-sep" aria-hidden="true">/</span>');
        trailEl.innerHTML = items;
      }
    }

    const nextTrail = [...state.categoryTrail, currentCollectionCrumb()];
    listEl.querySelectorAll('[data-csi-category-link]').forEach((link) => {
      const url = link.getAttribute('href')?.split('?')[0] || link.dataset.handle;
      const handle = link.dataset.handle || '';
      const title =
        link.dataset.title ||
        displayCollectionTitle(link.dataset.fullTitle || link.textContent);
      if (!url) return;
      // Keep link pointing at child collection with preserved filters + extended trail
      link.setAttribute('href', buildCollectionHref(url, nextTrail));
      link.setAttribute('data-title', title);
      if (!link.querySelector('span')) {
        link.innerHTML = `<span>${escapeHtml(title)}</span>`;
      }
    });
  }

  function buildRequestUrl() {
    const params = new URLSearchParams({
      limit: String(state.limit),
      offset: String(state.offset),
      sortId: state.sortId,
    });
    if (state.collectionHandle) params.set('collection', state.collectionHandle);
    if (state.filters.length > 0) params.set('filters', JSON.stringify(state.filters));
    const q = effectiveSearchQuery();
    if (q) params.set('q', q);
    return `${searchEndpoint}?${params.toString()}`;
  }

  function ensureSkeletonStyles() {
    if (document.getElementById(SKELETON_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = SKELETON_STYLE_ID;
    style.textContent = `
      @keyframes csi-search-skel-wipe {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
      }
      [data-csi-product-list][data-csi-skeletons="true"] {
        min-height: 28rem;
      }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        min-height: 28rem;
        pointer-events: none;
      }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__bone {
        position: relative;
        overflow: hidden;
        background: #e5e5e5 !important;
        border-radius: 0.45rem;
        display: block;
      }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__bone::after {
        content: "";
        position: absolute;
        inset: 0;
        transform: translateX(-100%);
        background: linear-gradient(
          90deg,
          rgba(255,255,255,0) 0%,
          rgba(255,255,255,0.2) 40%,
          rgba(255,255,255,0.75) 50%,
          rgba(255,255,255,0.2) 60%,
          rgba(255,255,255,0) 100%
        );
        animation: csi-search-skel-wipe 1.2s ease-in-out infinite;
      }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__media {
        width: 100%;
        aspect-ratio: 1 / 1;
        min-height: 14rem;
        border-radius: 0.7rem;
        background: #e5e5e5 !important;
      }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__line {
        height: 1.2rem;
      }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__line--lg { width: 100%; height: 1.5rem; }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__line--md { width: 72%; }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__line--sm { width: 48%; }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__line--xs { width: 34%; height: 1rem; }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0.6rem;
        margin-top: auto;
      }
      [data-csi-product-list][data-csi-skeletons="true"] .csi-search-skel__btn {
        height: 3.6rem;
        border-radius: 0.8rem;
      }
    `;
    document.head.appendChild(style);
  }

  function buildSkeletonCardHtml() {
    return `
      <li class="grid__item" aria-hidden="true">
        <div class="csi-search-skel" style="display:flex;flex-direction:column;gap:1rem;width:100%;min-height:28rem;">
          <div class="csi-search-skel__bone csi-search-skel__media" style="background:#e5e5e5;width:100%;aspect-ratio:1/1;min-height:14rem;border-radius:0.7rem;"></div>
          <div class="csi-search-skel__bone csi-search-skel__line csi-search-skel__line--xs" style="background:#e5e5e5;width:34%;height:1rem;border-radius:0.45rem;"></div>
          <div class="csi-search-skel__bone csi-search-skel__line csi-search-skel__line--lg" style="background:#e5e5e5;width:100%;height:1.5rem;border-radius:0.45rem;"></div>
          <div class="csi-search-skel__bone csi-search-skel__line csi-search-skel__line--md" style="background:#e5e5e5;width:72%;height:1.2rem;border-radius:0.45rem;"></div>
          <div class="csi-search-skel__bone csi-search-skel__line csi-search-skel__line--sm" style="background:#e5e5e5;width:48%;height:1.2rem;border-radius:0.45rem;"></div>
          <div class="csi-search-skel__actions" style="display:grid;grid-template-columns:1fr 1fr;gap:0.6rem;margin-top:auto;">
            <div class="csi-search-skel__bone csi-search-skel__btn" style="background:#e5e5e5;height:3.6rem;border-radius:0.8rem;"></div>
            <div class="csi-search-skel__bone csi-search-skel__btn" style="background:#e5e5e5;height:3.6rem;border-radius:0.8rem;"></div>
          </div>
        </div>
      </li>
    `;
  }

  function renderSkeletons(count = state.limit) {
    if (!els.list) return;
    if (els.empty) els.empty.hidden = true;
    ensureSkeletonStyles();
    els.list.dataset.csiSkeletons = 'true';
    const n = Math.max(1, Number(count) || 12);
    els.list.innerHTML = Array.from({ length: n }, () => buildSkeletonCardHtml()).join('');
    skeletonShownAt = Date.now();
  }

  function setLoading(isLoading) {
    root.classList.toggle('is-loading', isLoading);
    // Never show the Dawn loading overlay — skeletons are the loading UI.
    if (els.loading) els.loading.hidden = true;
    if (isLoading) {
      loadingGeneration += 1;
      renderSkeletons(state.limit);
    }
  }

  function waitForSkeletonFloor(generation) {
    const elapsed = Date.now() - skeletonShownAt;
    const remaining = Math.max(0, SKELETON_MIN_MS - elapsed);
    if (remaining === 0) return Promise.resolve();
    return new Promise((resolve) => {
      setTimeout(() => {
        if (generation === loadingGeneration) resolve();
        else resolve();
      }, remaining);
    });
  }

  function numericFromGid(value) {
    const raw = String(value || '');
    return raw.match(/\/(\d+)$/)?.[1] || raw.replace(/\D/g, '') || '';
  }

  function variantIdsFromProduct(product) {
    const fromGids = (product.variantGids || [])
      .map((gid) => numericFromGid(gid))
      .filter(Boolean);
    if (fromGids.length) return [...new Set(fromGids)];
    const fallback = numericFromGid(product.variantId);
    return fallback ? [fallback] : [];
  }

  function isContactForPricingLabel(price) {
    const value = String(price || '').toLowerCase();
    return value.includes('contact') || value.includes('login for pricing');
  }

  function renderPriceHtml(product, url) {
    if (!isLoggedIn) {
      return `<a class="csi-search__contact-pricing login_for_pricing" href="${escapeHtml(loginUrl)}">Contact for pricing</a>`;
    }

    const price = product.price ? String(product.price) : '';
    if (!price || isContactForPricingLabel(price)) {
      return `<a class="csi-search__contact-pricing login_for_pricing" href="${url}#contact-for-price">Contact for pricing</a>`;
    }

    return `<div class="price"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">${escapeHtml(price)}</span></div></div></div>`;
  }

  function renderActionsHtml(product, numericId, handle) {
    const variantIds = variantIdsFromProduct(product);
    const firstVariantId = variantIds[0] || '';
    // Hide ATC when custom.contact_for_pricing is true. $0.01 sentinel may still
    // show "Contact for pricing" as the label, but ATC stays available if the
    // metafield is false.
    const canAddToCart =
      isCompanyLoggedIn &&
      Boolean(firstVariantId) &&
      product.availableForSale !== false &&
      product.contactForPricing !== true;

    const quoteButton = numericId
      ? `<div class="ify-quote-group ify-quote-group-${numericId}" data-targetid="${numericId}" data-targethandle="${handle}">
          <button
            type="button"
            class="csi-search__action csi-search__action--quote storeify-quote-btn-trigger-popup ify-button-code"
            data-product="${handle}"
            aria-label="Add to quote"
          >
            <span class="svg-wrapper">${QUOTE_ICON}</span>
            <span>Add to Quote</span>
          </button>
        </div>`
      : '';

    const cartButton = canAddToCart
      ? `<button
            type="button"
            class="csi-search__action csi-search__action--cart"
            data-csi-add-to-cart
            data-variant-id="${escapeHtml(firstVariantId)}"
            aria-label="Add to cart"
          >
            <span class="svg-wrapper">${CART_ICON}</span>
            <span>Add to Cart</span>
          </button>`
      : '';

    if (!quoteButton && !cartButton) return '';

    const layoutClass = cartButton
      ? 'csi-search__actions'
      : 'csi-search__actions csi-search__actions--quote-only';

    return `<div class="${layoutClass}">${quoteButton}${cartButton}</div>`;
  }

  async function addVariantToCart(variantId, button) {
    let cartAddUrl = window.routes?.cart_add_url || '/cart/add';
    if (!/\.js(\?|$)/.test(cartAddUrl)) {
      cartAddUrl = `${cartAddUrl.replace(/\/?$/, '')}.js`;
    }
    const cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');
    button.disabled = true;

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cart?.getSectionsToRender) {
        const sectionIds = cart
          .getSectionsToRender()
          .map((section) => section.id)
          .filter(Boolean);
        if (sectionIds.length) {
          formData.append('sections', sectionIds.join(','));
        }
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'csi-search',
          productVariantId: variantId,
          cartData: data,
        });
      }

      if (cart?.renderContents) {
        cart.renderContents(data);
      } else if (window.routes?.cart_url) {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      console.error('[csi-search] add to cart failed', error);
      window.alert(error?.message || 'Could not add to cart');
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
      button.disabled = false;
    }
  }

  function renderProducts(products) {
    if (!els.list) return;
    delete els.list.dataset.csiSkeletons;

    if (!products.length) {
      els.list.innerHTML = '';
      if (els.empty) els.empty.hidden = false;
      return;
    }
    if (els.empty) els.empty.hidden = true;

    els.list.innerHTML = products
      .map((product) => {
        const url = escapeHtml(product.url || `/products/${product.handle}`);
        const title = escapeHtml(product.title || '');
        const fullTitle = title;
        const vendor = escapeHtml(product.vendor || '');
        const sku = escapeHtml(product.sku || '');
        const handle = escapeHtml(product.handle || '');
        const numericId = numericFromGid(product.id);
        const imageUrl = product.imageUrl || product.image?.url;
        const imageAlt = escapeHtml(
          product.imageAlt || product.image?.altText || product.title || '',
        );

        const mediaHtml = imageUrl
          ? `<img src="${escapeHtml(imageUrl)}" alt="${imageAlt}" class="motion-reduce" loading="lazy" width="533" height="533">`
          : '';

        const vendorHtml =
          showVendor && vendor
            ? `<div class="caption-with-letter-spacing light"><span class="product-vendor">${vendor}</span></div>`
            : '';
        const skuHtml = sku ? `<div class="product-sku">SKU: ${sku}</div>` : '';
        const priceHtml = renderPriceHtml(product, url);
        const actionsHtml = renderActionsHtml(product, numericId, handle);

        return `
          <li class="grid__item">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media" style="--ratio-percent: 100%;" data-product-id="${escapeHtml(numericId)}" data-product-handle="${handle}">
                <div class="card__inner ratio" style="--ratio-percent: 100%;">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      ${mediaHtml}
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information"></div>
                  </div>
                </div>
                <div class="card__content">
                  <div class="card__information">
                    ${vendorHtml}
                    <h3 class="card__heading h5">
                      <a href="${url}" class="full-unstyled-link" title="${fullTitle}">${title}</a>
                    </h3>
                    <div class="card-information">
                      ${skuHtml}
                      ${priceHtml}
                    </div>
                    ${actionsHtml}
                  </div>
                </div>
              </div>
            </div>
          </li>
        `;
      })
      .join('');

    document.dispatchEvent(
      new CustomEvent('csi:products-rendered', {
        detail: { count: products.length, root },
      }),
    );
  }

  function isFilterActive(filter) {
    const key = filterKey(filter);
    return state.filters.some((entry) => filterKey(entry) === key);
  }

  function toggleFacetFilter(rawInput) {
    let parsed;
    try {
      parsed = typeof rawInput === 'string' ? JSON.parse(rawInput) : rawInput;
    } catch {
      return;
    }
    const key = filterKey(parsed);
    const exists = state.filters.some((entry) => filterKey(entry) === key);
    state.filters = exists
      ? state.filters.filter((entry) => filterKey(entry) !== key)
      : [...state.filters.filter((entry) => !entry.price || !parsed.price), parsed];
    state.offset = 0;
    writeUrlState();
    runSearch();
  }

  function removeFilter(key) {
    state.filters = state.filters.filter((entry) => filterKey(entry) !== key);
    state.offset = 0;
    writeUrlState();
    runSearch();
  }

  function normalizePriceBounds(bounds) {
    if (!bounds || !Number.isFinite(bounds.min) || !Number.isFinite(bounds.max)) {
      return null;
    }
    const min = Number(bounds.min);
    const max = Number(bounds.max);
    if (max <= min) {
      return { min, max: min + 1 };
    }
    return { min, max };
  }

  function renderFacets(facets, priceBounds) {
    if (!els.facets) return;

    const openLabels = new Set(
      [...els.facets.querySelectorAll('details[open][data-csi-facet-key]')].map(
        (el) => el.getAttribute('data-csi-facet-key') || '',
      ).filter(Boolean),
    );

    const boundsForSlider =
      normalizePriceBounds(priceBounds) ||
      normalizePriceBounds(state.priceBounds) ||
      null;
    if (priceBounds) {
      state.priceBounds = normalizePriceBounds(priceBounds) || state.priceBounds;
    }

    const facetHtml = (facets || [])
      .map((facet) => {
        const usableValues = (facet.values || []).filter((value) => {
          const label = String(value.label || '').trim();
          if (!label) return false;
          if ((value.count || 0) > 0) return true;
          try {
            return isFilterActive(JSON.parse(value.input));
          } catch {
            return false;
          }
        });
        // Hide facet if fewer than 2 choices in the current result scope.
        if (usableValues.length <= 1) return null;

        return { facet, usableValues };
      })
      .filter(Boolean)
      .map((entry) => {
        const facet = entry.facet;
        const activeCount = entry.usableValues.filter((value) => {
          try {
            return isFilterActive(JSON.parse(value.input));
          } catch {
            return false;
          }
        }).length;

        const values = entry.usableValues
          .slice(0, 40)
          .map((value, valueIndex) => {
            let parsed = null;
            try {
              parsed = JSON.parse(value.input);
            } catch {
              parsed = null;
            }
            const active = parsed ? isFilterActive(parsed) : false;
            const hiddenClass =
              valueIndex >= FACET_VISIBLE_COUNT ? ' is-facet-overflow' : '';
            return `
              <li class="csi-search__facet-item${hiddenClass}">
                <button
                  type="button"
                  class="csi-search__facet-button${active ? ' is-active' : ''}"
                  data-csi-facet-input="${escapeHtml(value.input)}"
                >
                  <span>${escapeHtml(value.label)}</span>
                  <span class="csi-search__facet-count">(${value.count})</span>
                </button>
              </li>
            `;
          })
          .join('');

        const label = facet.label || 'Filter';
        const isOpen = openLabels.has(label);
        const overflowCount = Math.max(
          0,
          Math.min(entry.usableValues.length, 40) - FACET_VISIBLE_COUNT,
        );
        const isExpanded = expandedFacets.has(label);
        const showMoreHtml =
          overflowCount > 0
            ? `<button type="button" class="csi-search__facet-more" data-csi-facet-more="${escapeHtml(label)}">
                ${isExpanded ? 'Show less' : `Show more (${overflowCount})`}
              </button>`
            : '';

        return `
          <details class="facets__disclosure-vertical csi-search__facet-disclosure js-filter${isExpanded ? ' is-facet-expanded' : ''}" data-csi-facet-key="${escapeHtml(label)}"${isOpen ? ' open' : ''}>
            <summary class="facets__summary caption-large focus-offset">
              <div>
                <span class="facets__summary-label">
                  ${escapeHtml(label)}
                  <span class="facets__selected${activeCount === 0 ? ' hidden' : ''}">(${activeCount})</span>
                </span>
                ${CARET_SVG}
              </div>
            </summary>
            <div class="facets__display-vertical">
              <ul class="csi-search__facet-list facets__list--vertical list-unstyled" role="list">${values}</ul>
              ${showMoreHtml}
            </div>
          </details>
        `;
      })
      .join('');

    let priceHtml = '';
    const hasPriceRange =
      boundsForSlider &&
      Number.isFinite(boundsForSlider.min) &&
      Number.isFinite(boundsForSlider.max) &&
      boundsForSlider.max > boundsForSlider.min;

    if (hasPriceRange) {
      const priceFilter = state.filters.find((entry) => entry.price)?.price;
      const trackMin = boundsForSlider.min;
      const trackMax = boundsForSlider.max;
      let min = Number(priceFilter?.min ?? trackMin);
      let max = Number(priceFilter?.max ?? trackMax);
      min = Math.max(trackMin, Math.min(min, trackMax));
      max = Math.max(trackMin, Math.min(max, trackMax));
      if (min > max) {
        const swap = min;
        min = max;
        max = swap;
      }
      const span = trackMax - trackMin || 1;
      const leftPct = ((min - trackMin) / span) * 100;
      const rightPct = ((max - trackMin) / span) * 100;
      const priceOpen = openLabels.has('Price');
      priceHtml = `
        <details class="facets__disclosure-vertical csi-search__facet-disclosure js-filter" data-csi-facet-key="Price" data-csi-price-facet${priceOpen ? ' open' : ''}>
          <summary class="facets__summary caption-large focus-offset">
            <div>
              <span class="facets__summary-label">Price</span>
              ${CARET_SVG}
            </div>
          </summary>
          <div class="facets__display-vertical">
            <div
              class="csi-search__price-slider"
              data-csi-price-slider
              data-min="${trackMin}"
              data-max="${trackMax}"
              style="--csi-price-left:${leftPct}%;--csi-price-right:${rightPct}%;"
            >
              <div class="csi-search__price-slider-track" data-csi-price-track aria-hidden="true"></div>
              <input type="range" step="0.01" min="${trackMin}" max="${trackMax}" value="${min}" data-csi-price-min-range aria-label="Min price">
              <input type="range" step="0.01" min="${trackMin}" max="${trackMax}" value="${max}" data-csi-price-max-range aria-label="Max price">
            </div>
            <div class="csi-search__price-inputs">
              <input type="number" step="0.01" min="${trackMin}" max="${trackMax}" value="${min}" data-csi-price-min aria-label="Min price">
              <input type="number" step="0.01" min="${trackMin}" max="${trackMax}" value="${max}" data-csi-price-max aria-label="Max price">
            </div>
          </div>
        </details>
      `;
    }

    els.facets.innerHTML = `${priceHtml}${facetHtml}`;
    syncPriceSliderUi();
  }

  let priceApplyTimer = null;

  function syncPriceSliderUi() {
    const slider = root.querySelector('[data-csi-price-slider]');
    if (!slider) return;
    const minBound = Number(slider.dataset.min);
    const maxBound = Number(slider.dataset.max);
    const minRange = root.querySelector('[data-csi-price-min-range]');
    const maxRange = root.querySelector('[data-csi-price-max-range]');
    const minInput = root.querySelector('[data-csi-price-min]');
    const maxInput = root.querySelector('[data-csi-price-max]');
    const track = slider.querySelector('[data-csi-price-track]');
    if (!minRange || !maxRange) return;

    let minVal = Number(minRange.value);
    let maxVal = Number(maxRange.value);
    if (minVal > maxVal) {
      if (document.activeElement === minRange) maxVal = minVal;
      else minVal = maxVal;
      minRange.value = String(minVal);
      maxRange.value = String(maxVal);
    }
    if (minInput) minInput.value = String(minVal);
    if (maxInput) maxInput.value = String(maxVal);
    if (Number.isFinite(minBound) && Number.isFinite(maxBound) && maxBound > minBound) {
      const span = maxBound - minBound;
      const leftPct = Math.max(0, Math.min(100, ((minVal - minBound) / span) * 100));
      const rightPct = Math.max(0, Math.min(100, ((maxVal - minBound) / span) * 100));
      slider.style.setProperty('--csi-price-left', `${leftPct}%`);
      slider.style.setProperty('--csi-price-right', `${rightPct}%`);
      if (track) {
        track.style.background = `linear-gradient(to right, #d9d9d9 0%, #d9d9d9 ${leftPct}%, #0d5aa6 ${leftPct}%, #0d5aa6 ${rightPct}%, #d9d9d9 ${rightPct}%, #d9d9d9 100%)`;
      }
    }
  }

  function applyPriceFilterFromInputs() {
    const minInput = root.querySelector('[data-csi-price-min]');
    const maxInput = root.querySelector('[data-csi-price-max]');
    const min = Number(minInput?.value);
    const max = Number(maxInput?.value);
    if (!Number.isFinite(min) || !Number.isFinite(max)) return;
    state.filters = [
      ...state.filters.filter((entry) => !entry.price),
      { price: { min, max } },
    ];
    state.offset = 0;
    writeUrlState();
    runSearch();
  }

  function schedulePriceApply() {
    clearTimeout(priceApplyTimer);
    priceApplyTimer = setTimeout(applyPriceFilterFromInputs, 350);
  }

  function renderActiveFilters() {
    if (!els.activeFilters) return;
    if (!state.filters.length) {
      els.activeFilters.innerHTML = '';
      return;
    }

    els.activeFilters.innerHTML = state.filters
      .map((filter) => {
        const key = filterKey(filter);
        let label = 'Filter';
        if (filter.productVendor) label = filter.productVendor;
        else if (filter.productType) label = filter.productType;
        else if (filter.tag) label = filter.tag;
        else if (filter.productMetafield) label = filter.productMetafield.value;
        else if (filter.price) {
          label = `$${filter.price.min ?? ''}–$${filter.price.max ?? ''}`;
        }
        return `<button type="button" class="csi-search__chip" data-csi-remove-filter="${escapeHtml(key)}">${escapeHtml(label)} ×</button>`;
      })
      .join('');
  }

  function buildPageItems(current, totalPages) {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const items = new Set([1, totalPages, current]);
    for (let i = current - 1; i <= current + 1; i += 1) {
      if (i > 1 && i < totalPages) items.add(i);
    }
    // Prefer a short window near the start/end (e.g. 1 2 3 … last).
    if (current <= 3) {
      items.add(2);
      items.add(3);
    }
    if (current >= totalPages - 2) {
      items.add(totalPages - 1);
      items.add(totalPages - 2);
    }

    const sorted = [...items].filter((n) => n >= 1 && n <= totalPages).sort((a, b) => a - b);
    const result = [];
    for (let i = 0; i < sorted.length; i += 1) {
      const page = sorted[i];
      if (i > 0 && page - sorted[i - 1] > 1) result.push('…');
      result.push(page);
    }
    return result;
  }

  function renderPagination(pageInfo, total) {
    if (!els.pagination) return;
    const { offset, limit, hasNextPage, hasPreviousPage } = pageInfo;
    if (total <= limit) {
      els.pagination.hidden = true;
      els.pagination.innerHTML = '';
      return;
    }

    const page = Math.floor(offset / limit) + 1;
    const pages = Math.max(1, Math.ceil(total / limit));
    const items = buildPageItems(page, pages);

    const pageButtons = items
      .map((item) => {
        if (item === '…') {
          return `<span class="csi-search__page-ellipsis" aria-hidden="true">…</span>`;
        }
        const active = item === page;
        return `
          <button
            type="button"
            class="csi-search__page-num${active ? ' is-active' : ''}"
            data-csi-page="${item}"
            aria-label="Page ${item}"
            ${active ? 'aria-current="page"' : ''}
          >${item}</button>
        `;
      })
      .join('');

    els.pagination.hidden = false;
    els.pagination.innerHTML = `
      <div class="csi-search__pager" role="navigation" aria-label="Pagination">
        ${
          hasPreviousPage
            ? `<button type="button" class="csi-search__page-nav" data-csi-page="prev" aria-label="Previous page"><span class="svg-wrapper">${CHEVRON_LEFT_ICON}</span></button>`
            : ''
        }
        ${pageButtons}
        ${
          hasNextPage
            ? `<button type="button" class="csi-search__page-nav" data-csi-page="next" aria-label="Next page"><span class="svg-wrapper">${CHEVRON_RIGHT_ICON}</span></button>`
            : ''
        }
      </div>
    `;
  }

  function stripNumericCollectionPrefix(title) {
    if (!title || typeof title !== 'string') return title || '';
    // "6075-HPLC Products" → "HPLC Products"; leave titles without a numeric prefix alone
    return title.replace(/^\d+-\s*/, '').trim() || title;
  }

  function renderStatus(data) {
    if (!els.status) return;
    if (!data?.ok) {
      els.status.textContent = data?.error
        ? `Search unavailable: ${data.error}`
        : 'Search unavailable. Please try again.';
      return;
    }
    const total = data.estimatedTotalHits ?? 0;
    const start = total === 0 ? 0 : data.pageInfo.offset + 1;
    const end = data.pageInfo.offset + (data.products?.length || 0);
    const q = data.query ? ` for “${data.query}”` : '';
    const collectionLabel = stripNumericCollectionPrefix(data.collectionTitle);
    const scope = collectionLabel ? ` in ${collectionLabel}` : '';
    els.status.textContent =
      total === 0
        ? `No results${q}${scope}`
        : `Showing ${start.toLocaleString()}–${end.toLocaleString()} of ${total.toLocaleString()}${q}${scope}`;
  }

  async function runSearch() {
    setLoading(true);
    const generation = loadingGeneration;
    if (state.abortController) state.abortController.abort();
    const controller = new AbortController();
    state.abortController = controller;

    try {
      const response = await fetch(buildRequestUrl(), {
        signal: controller.signal,
        headers: { Accept: 'application/json' },
      });
      const data = await response.json().catch(() => ({ ok: false, error: 'Invalid response' }));
      if (!response.ok && data.ok !== false) {
        data.ok = false;
        data.error = data.error || `HTTP ${response.status}`;
      }

      // Keep skeletons visible long enough to be perceived (fast API otherwise flashes).
      await waitForSkeletonFloor(generation);
      if (state.abortController !== controller) return;

      renderStatus(data);
      state.hasLoadedOnce = true;

      if (!data.ok) {
        renderProducts([]);
        if (els.facets) els.facets.innerHTML = '';
        if (els.pagination) els.pagination.hidden = true;
        return;
      }

      state.priceBounds = normalizePriceBounds(data.priceBounds) || state.priceBounds;
      renderProducts(data.products || []);
      renderFacets(data.facets || [], data.priceBounds);
      renderActiveFilters();
      const browsableTotal =
        data.pageInfo?.totalBrowsable ?? data.estimatedTotalHits ?? 0;
      renderPagination(data.pageInfo, browsableTotal);
    } catch (error) {
      if (error?.name === 'AbortError') return;
      state.hasLoadedOnce = true;
      renderStatus({ ok: false, error: error.message || 'Search failed' });
      renderProducts([]);
    } finally {
      if (state.abortController === controller) {
        setLoading(false);
      }
    }
  }

  els.form?.addEventListener('submit', (event) => {
    event.preventDefault();
    applyInputToState(els.input?.value);
    state.offset = 0;
    writeUrlState();
    runSearch();
  });

  let queryDebounceTimer = null;
  els.input?.addEventListener('input', () => {
    const nextValue = els.input?.value.trim() || '';
    clearTimeout(queryDebounceTimer);
    queryDebounceTimer = setTimeout(() => {
      const prevRefine = state.refineQuery;
      const prevScope = state.scopeQuery;
      applyInputToState(nextValue);
      const unchanged = usesRefineInput()
        ? nextValue === prevRefine
        : nextValue === combineScopeRefine(prevScope, '');
      if (unchanged) return;
      state.offset = 0;
      writeUrlState();
      runSearch();
    }, 100);
  });

  els.sort?.addEventListener('change', () => {
    state.sortId = els.sort.value || 'relevance';
    state.offset = 0;
    writeUrlState();
    runSearch();
  });

  const pageSizeSelect = root.querySelector('[data-csi-page-size]');
  pageSizeSelect?.addEventListener('change', () => {
    const next = Number(pageSizeSelect.value);
    if (!Number.isFinite(next) || next <= 0) return;
    state.limit = next;
    state.offset = 0;
    root.dataset.pageSize = String(next);
    writeUrlState();
    runSearch();
  });

  root.addEventListener('click', (event) => {
    const addToCartBtn = event.target.closest('[data-csi-add-to-cart]');
    if (addToCartBtn) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = addToCartBtn.getAttribute('data-variant-id');
      if (variantId) addVariantToCart(variantId, addToCartBtn);
      return;
    }

    const facetBtn = event.target.closest('[data-csi-facet-input]');
    if (facetBtn) {
      toggleFacetFilter(facetBtn.getAttribute('data-csi-facet-input'));
      return;
    }

    const moreBtn = event.target.closest('[data-csi-facet-more]');
    if (moreBtn) {
      event.preventDefault();
      const label = moreBtn.getAttribute('data-csi-facet-more') || '';
      const details = moreBtn.closest('details');
      const hiddenCount = details?.querySelectorAll('.is-facet-overflow').length || 0;
      if (expandedFacets.has(label)) {
        expandedFacets.delete(label);
        details?.classList.remove('is-facet-expanded');
        moreBtn.textContent = `Show more (${hiddenCount})`;
      } else {
        expandedFacets.add(label);
        details?.classList.add('is-facet-expanded');
        moreBtn.textContent = 'Show less';
      }
      return;
    }

    const removeBtn = event.target.closest('[data-csi-remove-filter]');
    if (removeBtn) {
      removeFilter(removeBtn.getAttribute('data-csi-remove-filter'));
      return;
    }

    const pageBtn = event.target.closest('[data-csi-page]');
    if (pageBtn && !pageBtn.disabled) {
      const dir = pageBtn.getAttribute('data-csi-page');
      if (dir === 'next') {
        state.offset = state.offset + state.limit;
      } else if (dir === 'prev') {
        state.offset = Math.max(0, state.offset - state.limit);
      } else {
        const pageNum = Number(dir);
        if (!Number.isFinite(pageNum) || pageNum < 1) return;
        state.offset = (pageNum - 1) * state.limit;
      }
      writeUrlState();
      runSearch();
      window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
    }
  });

  root.addEventListener('input', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    if (
      target.matches('[data-csi-price-min-range], [data-csi-price-max-range]')
    ) {
      syncPriceSliderUi();
      schedulePriceApply();
      return;
    }

    if (target.matches('[data-csi-price-min], [data-csi-price-max]')) {
      const minInput = root.querySelector('[data-csi-price-min]');
      const maxInput = root.querySelector('[data-csi-price-max]');
      const minRange = root.querySelector('[data-csi-price-min-range]');
      const maxRange = root.querySelector('[data-csi-price-max-range]');
      if (minRange && minInput) minRange.value = minInput.value;
      if (maxRange && maxInput) maxRange.value = maxInput.value;
      syncPriceSliderUi();
    }
  });

  root.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.matches('[data-csi-price-min], [data-csi-price-max]')) {
      schedulePriceApply();
    }
  });

  els.filtersOpenBtns.forEach((btn) => {
    btn.addEventListener('click', () => openFiltersDrawer());
  });
  els.filtersCloseBtns.forEach((btn) => {
    btn.addEventListener('click', () => closeFiltersDrawer());
  });
  els.filtersBackdrop?.addEventListener('click', () => closeFiltersDrawer());
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-filters-open')) {
      closeFiltersDrawer();
    }
  });
  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 990px)').matches) {
      closeFiltersDrawer();
    }
  });

  ensureSkeletonStyles();
  readUrlState();
  writeUrlState();
  renderCategoryTree();
  setFiltersOpen(false);
  updateBreadcrumbs();
  renderSkeletons(state.limit);
  runSearch();
})();
